var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brandlogo"},[_c('img',{class:_vm.getCurrentTheme.type,attrs:{"src":_vm.imageSrc,"title":_vm.imageTitle}}),(_vm.getCurrentTheme.type === 'default')?_c('span',{staticClass:"logo-sub"},[_vm._v("maps")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }